/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BuildingKindEnum } from './buildingKindEnum';
import { InspectionReportEnum } from './inspectionReportEnum';
import { BathEquipmentEnum } from './bathEquipmentEnum';
import { PreservationTierEnum } from './preservationTierEnum';
import { WellTypeEnum } from './wellTypeEnum';
import { OwnershipEnum } from './ownershipEnum';
import { RoofStructureIssueEnum } from './roofStructureIssueEnum';
import { PhaseCountEnum } from './phaseCountEnum';
import { WindowChangeEnum } from './windowChangeEnum';
import { HouseTypeEnum } from './houseTypeEnum';
import { PropertyRequestEnergyCostsInner } from './propertyRequestEnergyCostsInner';
import { BuildingTypeEnum } from './buildingTypeEnum';
import { RoofInsulationEnum } from './roofInsulationEnum';
import { EquipmentConditionEnum } from './equipmentConditionEnum';
import { ObjectLocationEnum } from './objectLocationEnum';
import { CableMaterialTypeEnum } from './cableMaterialTypeEnum';
import { WaterHeatingEnum } from './waterHeatingEnum';
import { PropertyTypeEnum } from './propertyTypeEnum';
import { FloodAreaEnum } from './floodAreaEnum';
import { HeatingSourceEnum } from './heatingSourceEnum';
import { AtticInsulationEnum } from './atticInsulationEnum';
import { StairsTypeEnum } from './stairsTypeEnum';
import { EnergyCertificateClassEnum } from './energyCertificateClassEnum';
import { InternetConnectionTypeEnum } from './internetConnectionTypeEnum';
import { TelecommunicationEnum } from './telecommunicationEnum';
import { HeatingEnum } from './heatingEnum';
import { TestAndServiceReportEnum } from './testAndServiceReportEnum';
import { FlatDispositionEnum } from './flatDispositionEnum';
import { HouseCellarTypeEnum } from './houseCellarTypeEnum';
import { VerticalStructureEnum } from './verticalStructureEnum';
import { FencedEnum } from './fencedEnum';
import { HorizontalStructureEnum } from './horizontalStructureEnum';
import { OtherBuildingEnum } from './otherBuildingEnum';
import { CellarTypeEnum } from './cellarTypeEnum';
import { ProjectDocumentationEnum } from './projectDocumentationEnum';
import { AtticLivableEnum } from './atticLivableEnum';
import { BarrierFreeApartmentEnum } from './barrierFreeApartmentEnum';
import { RoofTypeEnum } from './roofTypeEnum';
import { MainCircuitBreakerEnum } from './mainCircuitBreakerEnum';
import { PropertyRequestAccount } from './propertyRequestAccount';
import { CeilingInsulationEnum } from './ceilingInsulationEnum';
import { ParkingEnum } from './parkingEnum';
import { FoundationEnum } from './foundationEnum';
import { RoofCoveringEnum } from './roofCoveringEnum';
import { ReconstructionDocumentationEnum } from './reconstructionDocumentationEnum';
import { WindowTypeEnum } from './windowTypeEnum';
import { ExteriorFacadeConditionEnum } from './exteriorFacadeConditionEnum';
import { HotWaterSourceEnum } from './hotWaterSourceEnum';
import { RoofStructureEnum } from './roofStructureEnum';


export interface PropertyRequest { 
    name?: string | null;
    type: PropertyTypeEnum;
    city?: string | null;
    cityCode?: string | null;
    catastralArea?: string | null;
    catastralAreaCode?: string | null;
    landNumber?: string | null;
    plotNumber?: string | null;
    buildingNumber?: string | null;
    totalLandArea?: number | null;
    usableAreaMainBuilding?: number | null;
    familyHousehold?: boolean | null;
    buildingTypeOther?: string | null;
    houseType?: HouseTypeEnum;
    aboveGroundFloors?: number | null;
    undergroundFloors?: number | null;
    /**
     * Rok kolaudace.
     */
    yearOfCompletion?: string | null;
    /**
     * Rok výstavby.
     */
    yearOfConstruction?: string | null;
    locationOfObjectOther?: string | null;
    numberOfResidentialRooms?: number | null;
    numberOfOtherRooms?: number | null;
    /**
     * Prodej po částech.
     */
    saleByParts?: boolean | null;
    /**
     * Minimální výměra částí.
     */
    minPartSize?: number | null;
    /**
     * Právní přístup k pozemkům.
     */
    legalAccessToArea?: boolean | null;
    /**
     * Lze přístup řešit.
     */
    resolveAccessToArea?: boolean | null;
    /**
     * Poznámka k přístupu.
     */
    accessToAreaNote?: string | null;
    /**
     * Využitelnost pozemku.
     */
    areaUsability?: string | null;
    /**
     * Geodetem v terénu vytyčeno
     */
    geodet?: boolean | null;
    /**
     * Jak vytyčeno (geodetem)
     */
    geodetHow?: string | null;
    /**
     * Oplocení.
     */
    fenced?: FencedEnum;
    /**
     * Odpovídá mapě KN
     */
    knMap?: boolean | null;
    /**
     * Stavby na pozemku
     */
    areaBuildings?: boolean | null;
    /**
     * Stavby na pozemku (Jaké)
     */
    areaBuildingsWhat?: string | null;
    /**
     * Připravenost ke stavbě
     */
    buildingReady?: string | null;
    /**
     * Projektová dokumentace k přípojkám
     */
    plugDocs?: boolean | null;
    /**
     * Projektová dokumentace k výstavbě
     */
    buildDocs?: boolean | null;
    /**
     * V případě, že ANO je nutný souhlas projektanta
     */
    projectAgree?: string | null;
    /**
     * Revizní zprávy k přípojkám elektřiny
     */
    plugRevision?: boolean | null;
    /**
     * Bude součástí prodeje
     */
    partOfSale?: string | null;
    /**
     * Revizní zprávy k přípojkám plynu
     */
    gasRevisions?: boolean | null;
    /**
     * Vedení procházející pozemkem
     */
    powerLines?: boolean | null;
    /**
     * Jaké vedení
     */
    powerLinesNote?: string | null;
    /**
     * Typ rekuperace
     */
    recuperationType?: string | null;
    /**
     * Typ klimatizace
     */
    coolerType?: string | null;
    /**
     * Omezení stavebního úřadu
     */
    councilRestriction?: boolean | null;
    /**
     * Jaké omezení
     */
    councilRestrictionNote?: string | null;
    /**
     * Regulativa pozemků
     */
    landRegulative?: boolean | null;
    /**
     * Jaká regulativa
     */
    landRegulativeNote?: string | null;
    /**
     * Zatížení pozemku/závazky vůči třetím osobám
     */
    landObligations?: string | null;
    /**
     * Známé nedostatky nemovitosti
     */
    landFinalNote?: string | null;
    /**
     * Další vybavení objektu
     */
    additionalEquipment?: string | null;
    numberOfPeople?: number | null;
    /**
     * Průkaz energetické náročnosti budovy
     */
    penb?: EnergyCertificateClassEnum;
    /**
     * PENB předáno
     */
    penbSubmitted?: boolean | null;
    /**
     * PENB Bude zadáno ke zpracování
     */
    penbProcesss?: boolean | null;
    /**
     * PENB bude dodáno klientem do
     */
    penbUntill?: string | null;
    /**
     * Poznámka k PENB
     */
    penbNote?: string | null;
    /**
     * Bude dodáno vyúčtování energií za poslední 3 roky
     */
    penbFor3Years?: boolean | null;
    internetProvider?: string | null;
    internetConnection?: string | null;
    waterSupply?: boolean | null;
    waterConnected?: boolean | null;
    waterSupplyNote?: string | null;
    gasSupply?: boolean | null;
    gasConnected?: boolean | null;
    gasSupplyNote?: string | null;
    electricity?: boolean | null;
    electricityConnected?: boolean | null;
    electricityNote?: string | null;
    sewage?: boolean | null;
    sewageConnected?: boolean | null;
    sewageSepticTank?: boolean | null;
    sewageDrain?: boolean | null;
    sewageInfiltration?: boolean | null;
    sewageNote?: string | null;
    sewageWastewater?: boolean | null;
    sewageWastewaterConnected?: boolean | null;
    sewageWastewaterSepticTank?: boolean | null;
    sewageWastewaterDrain?: boolean | null;
    sewageWastewaterInfiltration?: boolean | null;
    sewageWastewaterNote?: string | null;
    sewageMixed?: boolean | null;
    sewageMixedConnected?: boolean | null;
    sewageMixedSepticTank?: boolean | null;
    sewageMixedDrain?: boolean | null;
    sewageMixedInfiltration?: boolean | null;
    sewageMixedNote?: string | null;
    /**
     * Jiné přípojky
     */
    otherConnections?: string | null;
    /**
     * Vybavenost (vybavení pevně spojené s nemovitostí)
     */
    equipment?: string | null;
    /**
     * Soupis zařízení, které zůstane po prodeji (např. židle, stůl sedací souprava atp.)
     */
    furnishingsForSale?: string | null;
    /**
     * Základy
     */
    foundation?: FoundationEnum;
    waterproofing?: boolean | null;
    originalCondition?: boolean | null;
    afterRepair?: boolean | null;
    defects?: string | null;
    verticalStructuresWaterproofing?: boolean | null;
    verticalStructuresOriginalCondition?: boolean | null;
    verticalStructuresAfterRepair?: boolean | null;
    verticalStructuresDefects?: string | null;
    horizontalStructuresOther?: string | null;
    horizontalStructuresOriginalCondition?: boolean | null;
    horizontalStructuresAfterRepair?: boolean | null;
    horizontalStructuresDefects?: string | null;
    stairsMainOther?: string | null;
    /**
     * Indikace viditelných poškození
     */
    visibleDamage?: boolean | null;
    /**
     * Poznámky k viditelným poškozením
     */
    damageNotes?: string | null;
    roofTypeOther?: string | null;
    /**
     * Typ střešní konstrukce
     */
    roofStructure?: RoofStructureEnum;
    roofStructureOther?: string | null;
    roofStructureIssuesOther?: string | null;
    /**
     * Typ střešní krytiny
     */
    roofCovering?: RoofCoveringEnum;
    roofCoveringCondition?: string | null;
    /**
     * Klempířské prvky - problémy
     */
    roofFittingsIssues?: string | null;
    /**
     * Difuzní fólie
     */
    diffusionFilm?: boolean | null;
    /**
     * Parotěsná zábrana
     */
    vaporBarrier?: boolean | null;
    /**
     * Materiál a tloušťka izolačního materiálu střechy.
     */
    insulationMaterialThicknessRoof?: string | null;
    /**
     * Hromosvod
     */
    lightningRod?: boolean | null;
    grounding?: boolean | null;
    lightningRodInspectionDate?: string | null;
    lightningRodNotes?: string | null;
    /**
     * Indikace přítomnosti komína.
     */
    chimney?: boolean | null;
    flueCount?: number | null;
    chimneyIssues?: string | null;
    chimneyInspectionDate?: string | null;
    flueInspectionDate?: string | null;
    /**
     * Materiál a tloušťka izolace.
     */
    insulationMaterialThickness?: string | null;
    /**
     * Poznámky k povrchové úpravě.
     */
    surfaceTreatmentNotes?: string | null;
    /**
     * Viditelné problémy s vlhkostí.
     */
    visibleIssuesMoisture?: string | null;
    cellarWallMaterial?: string | null;
    cellarCeilingMaterial?: string | null;
    cellarFloorMaterial?: string | null;
    cellarHeightArea?: string | null;
    cellarVisibleIssues?: string | null;
    heatingSourcesOther?: string | null;
    hotWaterSourceOther?: string | null;
    hotWaterSourceNote?: string | null;
    wellType?: WellTypeEnum;
    waterTest?: boolean | null;
    waterTestYear?: string | null;
    waterTestNotes?: string | null;
    windowsCondition?: EquipmentConditionEnum;
    windowsDate?: string | null;
    windowsNotes?: string | null;
    doorsCondition?: EquipmentConditionEnum;
    doorsDate?: string | null;
    doorsNotes?: string | null;
    floorsCondition?: EquipmentConditionEnum;
    floorsDate?: string | null;
    floorsNotes?: string | null;
    bathroomCondition?: EquipmentConditionEnum;
    bathroomDate?: string | null;
    bathroomNotes?: string | null;
    kitchenCondition?: EquipmentConditionEnum;
    kitchenDate?: string | null;
    kitchenNotes?: string | null;
    internalWaterCondition?: EquipmentConditionEnum;
    internalWaterDate?: string | null;
    internalWaterNotes?: string | null;
    internalSewageCondition?: EquipmentConditionEnum;
    internalSewageDate?: string | null;
    internalSewageNotes?: string | null;
    internalGasCondition?: EquipmentConditionEnum;
    internalGasDate?: string | null;
    internalGasNotes?: string | null;
    electricalInstallationCondition?: EquipmentConditionEnum;
    electricalInstallationDate?: string | null;
    electricalInstallationNotes?: string | null;
    dataCablingCondition?: EquipmentConditionEnum;
    dataCablingDate?: string | null;
    dataCablingNotes?: string | null;
    security?: boolean | null;
    securityDetails?: string | null;
    securityNotes?: string | null;
    /**
     * Další zařízení a konstrukce.
     */
    additionalConstructions?: string | null;
    /**
     * Známé vady a nedostatky.
     */
    knownIssues?: string | null;
    otherDocumentation?: string | null;
    /**
     * Termín dotace.
     */
    grantDate?: string | null;
    /**
     * Účel dotace.
     */
    purposeOfGrant?: string | null;
    /**
     * Závazky vůči třetím osobám.
     */
    obligationsToThirdParties?: string | null;
    /**
     * Pozemky (p.č.)
     */
    unitNumber?: string | null;
    /**
     * Vlastnictví.
     */
    ownership?: OwnershipEnum;
    /**
     * Bytové družstvo
     */
    apartmentAssociation?: string | null;
    /**
     * IČO bytového družstva
     */
    apartmentAssociationId?: string | null;
    /**
     * Výše anuity.
     */
    anuityAmount?: number | null;
    /**
     * Převod na osobní vlastnictví.
     */
    conversionToPersonalOwnership?: boolean | null;
    /**
     * Datum uzavření nájemní smlouvy.
     */
    leaseAgreementDated?: string | null;
    flatDisposition?: FlatDispositionEnum;
    cellarType?: CellarTypeEnum;
    houseCellarType?: HouseCellarTypeEnum;
    /**
     * Datum předání bytu.
     */
    apartmentHandoverDate?: string | null;
    elevatorAvailable?: boolean | null;
    /**
     * Bezbarierový byt.
     */
    barrierFreeApartment?: BarrierFreeApartmentEnum;
    hasBalcony?: boolean | null;
    hasTerrace?: boolean | null;
    hasLoggia?: boolean | null;
    /**
     * Typ ohřevu vody.
     */
    waterHeating?: WaterHeatingEnum;
    waterHeatingNote?: string | null;
    /**
     * Prohlášení vlastníka od klienta.
     */
    ownerDeclarationFromClient?: boolean | null;
    /**
     * Datum prohlášení vlastníka od klienta.
     */
    ownerDeclarationFromClientDate?: string | null;
    /**
     * Příspěvek do opravného fondu.
     */
    repairFundContribution?: boolean | null;
    /**
     * Výše příspěvku do opravného fondu.
     */
    repairFundContributionAmount?: number | null;
    /**
     * Úvěr na rekonstrukci společných prostor.
     */
    loanForCommonAreasRenovation?: boolean | null;
    /**
     * Výše úvěru na rekonstrukci společných prostor.
     */
    loanForCommonAreasRenovationAmount?: number | null;
    /**
     * Stav vybavení bytu.
     */
    flatEquipmentCondition?: EquipmentConditionEnum;
    /**
     * Datum poslední kontroly nebo výměny vybavení bytu.
     */
    flatEquipmentDate?: string | null;
    flatEquipmentNotes?: string | null;
    street?: string | null;
    /**
     * Podíl na společných částech.
     */
    shareInCommonParts?: string | null;
    objectLocationNote?: string | null;
    /**
     * Poloha objektu.
     */
    cityPart?: string | null;
    /**
     * Číslo garážového nebo parkovacího stání.
     */
    parkNumber?: string | null;
    /**
     * Na pozemku parc. č.
     */
    landParc?: string | null;
    /**
     * Užitná plocha.
     */
    usableArea?: number | null;
    /**
     * Druh stavby.
     */
    otherBuildingType?: string | null;
    reconstruction?: string | null;
    reconstructionYear?: string | null;
    /**
     * Celkem za energie
     */
    energySum?: number | null;
    /**
     * LV č. pozemek pod domem.
     */
    flatAreaLv?: string | null;
    /**
     * LV č. společných prostor.
     */
    flatSharedLv?: string | null;
    /**
     * Jednotka (č. bytu).
     */
    flatUnitLv?: string | null;
    /**
     * Umístění bytu
     */
    flatLocation?: string | null;
    /**
     * Předán půdorys.
     */
    groundPlan?: boolean | null;
    cellarSize?: string | null;
    balconySize?: string | null;
    terraceSize?: string | null;
    loggiaSize?: string | null;
    /**
     * Orentace budovy.
     */
    buildingDirection?: string | null;
    /**
     * Další příslušenství k jednotce.
     */
    otherFlatAccessories?: string | null;
    /**
     * Zajistí makléř (prohlášení vlastníka od klienta).
     */
    declarationByAgent?: boolean | null;
    /**
     * Předpis služeb k 1.1.
     */
    servicesDeclaration?: string | null;
    /**
     * Kdy končí úvěr.
     */
    flatLoanEnd?: string | null;
    /**
     * Vyrovnání samonivelační stěrkou.
     */
    floorsSpatula?: boolean | null;
    /**
     * Klimatizace.
     */
    cooler?: boolean | null;
    coolerDate?: string | null;
    coolerBrand?: string | null;
    /**
     * Rekuperace.
     */
    recuperation?: boolean | null;
    recuperationDate?: string | null;
    recuperationBrand?: string | null;
    /**
     * Občanská vybavenost.
     */
    civilFacility?: string | null;
    /**
     * Nové technologie.
     */
    newTech?: string | null;
    /**
     * Odpovídá nákres na LV.
     */
    draftLv?: boolean | null;
    draftLvNote?: string | null;
    internetConnectionTypeNote?: string | null;
    sewageOther?: boolean | null;
    /**
     * Septik a vlastní ČOV (splašková).
     */
    sewageWasteSeptic?: boolean | null;
    /**
     * Septik a vlastní ČOV (smíšená).
     */
    sewageMixedSeptic?: boolean | null;
    otherBuildingsNote?: string | null;
    verticalStructuresNote?: string | null;
    /**
     * Výměna oken.
     */
    windowChangeType?: WindowChangeEnum;
    windowTypeNote?: string | null;
    /**
     * Izolace stropu.
     */
    ceilingInsulation?: CeilingInsulationEnum;
    /**
     * Materiál izolace stropu.
     */
    insulationMaterialThicknessCeiling?: string | null;
    /**
     * Půda.
     */
    attic?: boolean | null;
    atticInsulation?: AtticInsulationEnum;
    atticLivable?: AtticLivableEnum;
    mainCircuitBreakerNote?: string | null;
    /**
     * Druh pozemku.
     */
    plotType?: string | null;
    /**
     * Rovina.
     */
    plotFlat?: boolean | null;
    /**
     * Svah.
     */
    plotSteep?: boolean | null;
    waterSystem?: boolean | null;
    gasSystem?: boolean | null;
    electricitySystem?: boolean | null;
    sewageSystem?: boolean | null;
    sewageWastewaterSystem?: boolean | null;
    sewageMixedSystem?: boolean | null;
    waterConnectionAvailability?: boolean | null;
    gasConnectionAvailability?: boolean | null;
    electricityConnectionAvailability?: boolean | null;
    sewageConnectionAvailability?: boolean | null;
    sewageWastewaterConnectionAvailability?: boolean | null;
    sewageMixedConnectionAvailability?: boolean | null;
    /**
     * Hloubka studny.
     */
    wellDepth?: string | null;
    /**
     * Kolaudace kanalizačního řádu.
     */
    sewageApproved?: boolean | null;
    /**
     * Kolaudace vodovodního řádu.
     */
    waterApproved?: boolean | null;
    /**
     * Stavební povolení k výstavbě RD.
     */
    buildAllowed?: boolean | null;
    /**
     * Hlavní poznámky.
     */
    masterNotes?: string | null;
    /**
     * Pro byty
     */
    wallsIsolation?: boolean | null;
    wallsIsolationDate?: string | null;
    roofIsolation?: boolean | null;
    roofIsolationDate?: string | null;
    ceilingIsolation?: boolean | null;
    ceilingIsolationDate?: string | null;
    floorsIsolation?: boolean | null;
    floorsIsolationDate?: string | null;
    basementIsolation?: boolean | null;
    basementIsolationDate?: string | null;
    flatHeating?: boolean | null;
    flatHeatingNote?: string | null;
    flatHeatingType?: string | null;
    account?: PropertyRequestAccount;
    /**
     * Typ a druh budov.
     */
    buildingType?: Array<BuildingTypeEnum> | null;
    /**
     * Poloha a umístění objektu.
     */
    locationOfObject?: Array<BuildingKindEnum> | null;
    internetConnectionType?: Array<InternetConnectionTypeEnum> | null;
    /**
     * Typ svislých nosných konstrukcí
     */
    verticalStructures?: Array<VerticalStructureEnum> | null;
    /**
     * Typ vodorovných nosných konstrukcí
     */
    horizontalStructures?: Array<HorizontalStructureEnum> | null;
    /**
     * Typ hlavního schodiště
     */
    stairsMain?: Array<StairsTypeEnum> | null;
    /**
     * Typ střechy
     */
    roofType?: Array<RoofTypeEnum> | null;
    /**
     * Poruchy konstrukce krovu
     */
    roofStructureIssues?: Array<RoofStructureIssueEnum> | null;
    /**
     * Typ tepelné izolace střechy.
     */
    roofInsulation?: Array<RoofInsulationEnum> | null;
    /**
     * Stav vnější fasády budovy.
     */
    exteriorFasade?: Array<ExteriorFacadeConditionEnum> | null;
    /**
     * Zdroj topení.
     */
    heatingSource?: Array<HeatingSourceEnum> | null;
    /**
     * Zdroj teplé vody.
     */
    hotWaterSource?: Array<HotWaterSourceEnum> | null;
    mainCircuitBreaker?: Array<MainCircuitBreakerEnum> | null;
    phaseCount?: Array<PhaseCountEnum> | null;
    material?: Array<CableMaterialTypeEnum> | null;
    /**
     * Revizní zprávy.
     */
    inspectionReports?: Array<InspectionReportEnum> | null;
    testsAndServiceReports?: Array<TestAndServiceReportEnum> | null;
    documentationForReconstruction?: Array<ReconstructionDocumentationEnum> | null;
    projectDocumentation?: Array<ProjectDocumentationEnum> | null;
    telecommunication?: Array<TelecommunicationEnum> | null;
    /**
     * Typ topení.
     */
    heating?: Array<HeatingEnum> | null;
    /**
     * Poloha objektu.
     */
    objectLocation?: Array<ObjectLocationEnum> | null;
    /**
     * Parkovací místo.
     */
    parkingSpot?: Array<ParkingEnum> | null;
    /**
     * Další vybavení koupelny.
     */
    bathEquipment?: Array<BathEquipmentEnum> | null;
    /**
     * Ostatní budovy / vedlejší stavby.
     */
    otherBuildings?: Array<OtherBuildingEnum> | null;
    windowType?: Array<WindowTypeEnum> | null;
    /**
     * Povodnova zona.
     */
    floodArea?: Array<FloodAreaEnum> | null;
    /**
     * Třída ochrany.
     */
    preservationTier?: Array<PreservationTierEnum> | null;
    /**
     * Měsíční náklady na energie
     */
    energyCosts?: Array<PropertyRequestEnergyCostsInner> | null;
}
export namespace PropertyRequest {
}


